export default function useMobileModalRouter({
    hash,
    onOpen,
    onClose,
}: {
    hash: string;
    onOpen?: () => void;
    onClose?: () => void;
}) {
    const isShow = ref(false);
    const isLocked = useScrollLock(
        typeof document === 'undefined' ? null : document.body
    );
    const {
        open: openClosable,
        close: closeClosable,
        isOpened,
    } = useClosable(hash);

    const startBodyScrolling = () => {
        const scrollY = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
    };

    const open = () => {
        isShow.value = true;
        isLocked.value = true;
        onOpen?.();
        openClosable();
    };
    const close = (): void => {
        isShow.value = false;
        isLocked.value = false;
        startBodyScrolling();
        onClose?.();
        closeClosable();
    };

    watch(isOpened, value => {
        if (!value) {
            isLocked.value = false;
            isShow.value = false;
        }
    });

    return {
        open,
        close,
        isShow,
    };
}
